export const requestType = {
  addTeacher: "ADD_TEACHER",
  authUser: "AUTH_USER",
  logoutUser: "LOGOUT_USER",
  updateUser: "UPDATE_USER",
  deleteAccount: "DELETE_ACCOUNT",
  getUserDetails: "GET_USER_DETAILS",
  getSchools: "GET_SCHOOLS",
  forgotPassword: "FORGOT_PASSWORD",
  changePassword: "CHANGE_PASSWORD",
  getTeacherRequests: "GET_TEACHER_REQUESTS",
  requestTeacherAction: "REQUEST_TEACHER_ACTION",
  getMoodeIcons: "GET_MOOD_ICONS",
  getTeacherLogMoods: "GET_TEACHER_LOG_MOODS",
  addTeacherLogMoods: "TEACHER_LOG_MOOD",
  getTeacherStudent: "GET_TEACHER_STUDENTS",
  getConversationsMessages: "TEACHER_GET_CONVERSATIONS",
  getConversationMessages: "TEACHER_GET_CONVERSATION",
  addMessagesReaction: "TEACHER_MESSAGE_REACTION",
  getTeacherHomepage: "GET_TEACHER_HOMEPAGE",
  getTeacherStats: "TEACHER_GET_STATS",
  sendSupportMessage: "SEND_ENQUIRY",
};
